export const Image={
    logo1:require("../image/logo-1.png"),
}